import { KnmSubjectTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmSubjectTypeCodesEnum';

export const getIsComplete336Available = (
  isErp: boolean,
  isErknmStatusTypeWaitingCarryOut: boolean,
  isErknmStatusTypeCarriedOut: boolean,
  erknmCreatedDate: string | null | undefined,
  erknmStartDate: string | null | undefined,
  knmSubjectType: KnmSubjectTypeCodesEnum | '' | undefined,
) => {
  if (erknmCreatedDate == null || erknmStartDate == null) {
    return false;
  }

  const createDate: Date = new Date(erknmCreatedDate);
  const startDate: Date = new Date(erknmStartDate);

  const isErknmAvailable: boolean =
    !isErp &&
    ((isErknmStatusTypeWaitingCarryOut &&
      createDate <= new Date('2022-03-11') &&
      startDate >= new Date('2022-01-01') &&
      startDate <= new Date('2022-12-31')) ||
      (isErknmStatusTypeCarriedOut &&
        createDate <= new Date('2022-03-11') &&
        startDate >= new Date('2022-03-10') &&
        startDate <= new Date('2022-03-31')));

  const isErpAvailable: boolean =
    isErp &&
    ((knmSubjectType === KnmSubjectTypeCodesEnum.UL_IP &&
      ((isErknmStatusTypeWaitingCarryOut &&
        createDate <= new Date('2022-03-11') &&
        startDate >= new Date('2022-01-01') &&
        startDate <= new Date('2022-12-31')) ||
        (isErknmStatusTypeCarriedOut &&
          createDate <= new Date('2022-03-11') &&
          startDate >= new Date('2022-03-10') &&
          startDate <= new Date('2022-03-31')))) ||
      ((knmSubjectType === KnmSubjectTypeCodesEnum.OGV || knmSubjectType === KnmSubjectTypeCodesEnum.OMS) &&
        (isErknmStatusTypeWaitingCarryOut || isErknmStatusTypeCarriedOut) &&
        createDate < new Date('2022-04-26')));

  return isErp ? isErpAvailable : isErknmAvailable;
};
